import CompanyNameFieldTemplate from './template'
export default CompanyNameFieldTemplate
